/* eslint-disable react/require-default-props */
import React from 'react';
import { Title } from './styles';

interface AiManagementSectionTitleProps {
  className?: string;
  children: React.ReactNode;
}

const AiManagementSectionTitle: React.FC<AiManagementSectionTitleProps> = ({
  className = 'mb-3',
  children,
}) => <Title className={`font-weight-bold ${className}`}>{children}</Title>;

export default AiManagementSectionTitle;
